export default __webpack_public_path__ + "static/media/svg44.ba4e6c07.svg";